import { createContext, useContext, useState } from "react";
import ImportTaxSidebar from "../components/TaxImportDialog";

interface ITaxImportContext {
    openImportTax: () => void;
    toggleImportTax: () => void;
}

const TaxImportContext = createContext<ITaxImportContext | null>(null);

interface ITaxImportProviderProps {
    children: React.ReactNode;
}

export const TaxImportProvider = ({ children }: ITaxImportProviderProps) => {
    const [importTaxOpen, setImportTaxOpen] = useState(false);

    const openImportTax = () => setImportTaxOpen(true);
    const toggleImportTax = () => setImportTaxOpen((prev) => !prev);

    return (
        <TaxImportContext.Provider value={{ openImportTax, toggleImportTax }}>
            {children}
            <ImportTaxSidebar
                importTaxOpen={importTaxOpen}
                setImportTaxOpen={setImportTaxOpen}
            />
        </TaxImportContext.Provider>
    );
};

export const useTaxImportContext = () => {
    const context = useContext(TaxImportContext);
    if (!context) {
        throw new Error("useTaxImportContext must be used within TaxImportProvider");
    }
    return context;
};
